import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { QUERY_URL_PARAM, PRODUCT_INDEX_EN } from "../constants";
import { useInstantSearch } from "react-instantsearch";
interface SearchResultCountProps {
  resultsTitle?: string;
}
function SearchResultCount({ resultsTitle }: SearchResultCountProps) {
  const searchParams = useSearchParams();
  const { status, scopedResults } = useInstantSearch();
  const queryParam = searchParams.get(QUERY_URL_PARAM);
  const queryResultsLabel = resultsTitle ? resultsTitle : queryParam;
  const [numberOfHits, setNumberOfHits] = useState<number>(0);

  useEffect(() => {
    const totalHits = scopedResults.reduce((sum, { indexId, results }) => {
      if (indexId === PRODUCT_INDEX_EN) return sum;
      return sum + (results?._rawResults[0]?.nbHits || 0);
    }, 0);

    setNumberOfHits(totalHits);
  }, [scopedResults]);

  return (
    <div className={status !== "idle" ? "invisible" : ""}>
      <h2 className="text-2xl">
        {numberOfHits} results{" "}
        {queryResultsLabel ? `for "${queryResultsLabel}"` : null}
      </h2>
    </div>
  );
}

export default SearchResultCount;
